const INIT_STATE = { error: null };
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "GET_TOTAL_EMPLOYEE_STATS_SUCCESS":
      return {
        ...state,
        totalEmployee: action.payload.data,
        error: null,
      };
    case "GET_TOTAL_EMPLOYEE_STATS_ERROR":
      return { ...state, error: action.payload };
    case "GET_TRAINING_COMPLETENESS_STATS_SUCCESS":
      return {
        ...state,
        trainingCompleteness: action.payload.data,
        error: null,
      };
    case "GET_TRAINING_COMPLETENESS_STATS_ERROR":
      return { ...state, error: action.payload };
    case "GET_EMPLOYEE_TURNOVER_STATS_SUCCESS":
      // console.log(action.payload.data);
      return {
        ...state,
        employeeTurnover: action.payload.data,
        error: null,
      };
    case "GET_EMPLOYEE_TURNOVER_STATS_ERROR":
      return { ...state, error: action.payload };
    case "GET_ELEARNING_COMPLETENESS_STATS_SUCCESS":
      return {
        ...state,
        eLearningCompleteness: action.payload.data,
        error: null,
      };
    case "GET_ELEARNING_COMPLETENESS_STATS_ERROR":
      return { ...state, error: action.payload };
    default:
      return state;
  }
};
